import ConfigurationPage from "./ConfigurationPage";

export default ConfigurationPage
